import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';

const useInitialData = <T>(data: T, callback: (initialData: T, data: T) => void) => {
  const isChanged = useRef<boolean>(false);
  const initialData = useRef<T>(data);

  useEffect(() => {
    const isDataChanged = !isEqual(initialData.current, data);

    if (isDataChanged) {
      callback && callback(initialData.current, data);
      isChanged.current = true;
      initialData.current = data;
    }
  }, [callback, data]);

  return { isChanged, initialData };
};

export default useInitialData;
